import React from "react";
import LoginContainer from "../../../Components/Auth/Login/LoginContainer";

const Pages_Login = () => {
  return <LoginContainer />;
};

export default Pages_Login;
